/** Auth endpoints (gateway-local; rewritten to /users/auth/* in cloud mode by resolvePath). */
export const authEndpoints = {
  login: '/auth/login',
  verifyMfa: '/auth/login/mfa',
  mfaRecover: '/auth/mfa/recover',
  mfaRecoverConfirm: '/auth/mfa/recover/confirm',
  stepUp: '/auth/step-up',
  logout: '/auth/logout',
  refresh: '/auth/refresh',
} as const;
